import React, { useState } from 'react'
import { Form,Checkbox,Button,Table,Input,Select, message } from 'antd'
import axios from 'axios';
import { SERVER_ADDRESS } from '../../../Config/Config';
import { useNavigate } from 'react-router-dom';

const CreateAdmin = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const [priveleges,setPrivelege] = useState({users:{
        verification:false,
        create:false,
        edit:false,
        delete:false,
        subscription:false,
        suspend:false,
        fullAccess:false
    }})

    const handlePrivilegeChange = (module, privilege) => {
        setPrivelege((prev) => {
            const newPrivileges = { ...prev };
            if (privilege === "fullAccess") {
                const isChecked = !newPrivileges[module].fullAccess;
                newPrivileges[module] = {
                    verification: isChecked,
                    create: isChecked,
                    edit: isChecked,
                    delete: isChecked,
                    subscription:isChecked,
                    suspend:isChecked,
                    fullAccess: isChecked,
                };
            } else {
                newPrivileges[module][privilege] = !newPrivileges[module][privilege];

                // If any privilege is unchecked, uncheck Full Access
                if (!newPrivileges[module][privilege]) {
                    newPrivileges[module].fullAccess = false;
                }

                // If all are checked, check Full Access
                const allChecked = ["verification", "create", "edit", "delete","subscription","suspend"]
                    .every((key) => newPrivileges[module][key]);
                newPrivileges[module].fullAccess = allChecked;
            }
            return { ...newPrivileges };
        });
    };

    const layout = {
        labelCol: {
          span: 8,
        },
        wrapperCol: {
          span: 16,
        },
      };

    const roleOptions = [
        {
            value:"Admin",
            label:"Admin"
        },
        {
            value:"Sub-Admin",
            label:"Sub-Admin"
        }
    ]

    const columns = [
        {
            title: "Module",
            dataIndex: "module",
            render: (text) => <strong>{text} /<br />Bottom Sheet / <br />FAQ</strong>,
        },
        {
            title: "Verification",
            dataIndex: "verification",
            render: (_, record) => (
                <Checkbox
                    checked={priveleges[record.module].verification}
                    onChange={() => handlePrivilegeChange(record.module, "verification")}
                />
            ),
        },
        {
            title: "Create",
            dataIndex: "create",
            render: (_, record) => (
                <Checkbox
                    checked={priveleges[record.module].create}
                    onChange={() => handlePrivilegeChange(record.module, "create")}
                />
            ),
        },
        {
            title: "Edit",
            dataIndex: "edit",
            render: (_, record) => (
                <Checkbox
                    checked={priveleges[record.module].edit}
                    onChange={() => handlePrivilegeChange(record.module, "edit")}
                />
            ),
        },
        {
            title: "Delete",
            dataIndex: "delete",
            render: (_, record) => (
                <Checkbox
                    checked={priveleges[record.module].delete}
                    onChange={() => handlePrivilegeChange(record.module, "delete")}
                />
            ),
        },
        {
            title: "Suspend",
            dataIndex: "suspend",
            render: (_, record) => (
                <Checkbox
                    checked={priveleges[record.module].suspend}
                    onChange={() => handlePrivilegeChange(record.module, "suspend")}
                />
            ),
        },
        {
            title: "Subscription",
            dataIndex: "subscription",
            render: (_, record) => (
                <Checkbox
                    checked={priveleges[record.module].subscription}
                    onChange={() => handlePrivilegeChange(record.module, "subscription")}
                />
            ),
        },
        {
            title: "Full Access",
            dataIndex: "fullAccess",
            render: (_, record) => (
                <Checkbox
                    checked={priveleges[record.module].fullAccess}
                    onChange={() => handlePrivilegeChange(record.module, "fullAccess")}
                />
            ),
        },
    ];

    const data = [
        {
            key: "1",
            module: "users",
        }
    ];

    const getPrivilegesArray = () => {
        const modulePrivileges = priveleges.users;
        return Object.keys(modulePrivileges).filter(key => modulePrivileges[key] && key !== "fullAccess");
    };

    const handleSubmit = async(values)=>{
        const priveleges = getPrivilegesArray()
        if(priveleges.length === 0){
            message.warning({content:"Kindly Check priveleges"})
            return;
        }
        const payload = {
            ...values,
            priveleges:getPrivilegesArray()
        }
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/addAdmin`,{payload}) 
            navigate('/adminList');
        } catch (error) {
            console.log(error)
            if(error.status===400){
                message.error({content:error.response.data.message})
            }
            else{
                message.error({content:'Oops somethig wrong'})
            }
        }
    }
    
  return (
    <>
    <div className='' style={{backgroundColor:"white",padding:"4rem",marginTop:"4rem"}} >
        <h3>Add Admin / Sub Admin</h3>
        <div style={{marginTop:'3rem'}} >
            <Form {...layout} form={form} name='addAdmin' onFinish={handleSubmit} style={{width:'50%'}}  >
                <Form.Item style={{width:'50rem'}}
                    label='Name'
                    name={'name'}
                    rules={[{required:true,message:"Enter name"}]}
                >
                    <Input placeholder='Enter the Name' />
                </Form.Item>
                <Form.Item style={{width:'50rem'}}
                    label='Email'
                    name={'email'}
                    rules={[{required:true,message:"Enter Email"},{type:"email",message:"Enter valid Email"}]}
                >
                    <Input placeholder='Enter the Email' />
                </Form.Item>
                <Form.Item style={{width:'50rem'}}
                    label='Role'
                    name={'role'}
                    rules={[{required:true,message:"Select Role"}]}
                >
                    <Select placeholder='Select Role' options={roleOptions} />
                </Form.Item>
                <Form.Item style={{width:'50rem'}}
                    label='Password'
                    name={'password'}
                    rules={[{required:true,message:"Enter Password"}]}
                >
                    <Input.Password placeholder='Enter the Password' />
                </Form.Item>
                <div style={{marginLeft:"5rem",display:'flex',flexDirection:'column',justifyContent:'center',alignItems:"center"}} >
                <Table pagination={false} columns={columns} dataSource={data} style={{width:"80%"}} />
                </div>
                <Form.Item
                    style={{marginLeft:"50%",marginTop:"2rem"}}
                >
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </div>
    </div>
    </>
  )
}

export default CreateAdmin